// @flow

import * as React from 'react'
import { Container, Segment, Button } from 'semantic-ui-react'
import { Form, Fields, Validators } from 'react-redux-components'

type Props = {|
  mode: 'edit' | 'list' | 'add',
  pristine: boolean,
  username: string,
  onSubmit: (user: Object) => void,
  onResetPassword: () => void,
  onCancel: () => void,
|}

const UserForm = (props: Props) => {
  let validators = {
    username: { required: Validators.required },
    fullname: { required: Validators.required },
    role: { required: Validators.required },
  }

  let TextInput = Fields.TextInput

  return (
    <Container>
      <Form onSubmit={props.onSubmit} model="users.form" dimmable={true} validators={validators}>
        <Segment color="orange" secondary>
          <TextInput
            className="seven wide"
            label="Username"
            model=".username"
            disabled={props.mode === 'edit'}
            errorMessages={{
              required: 'Campo obbligatorio.',
            }}
          />
          <TextInput
            className="ten wide"
            label="Nome completo"
            model=".fullname"
            errorMessages={{
              required: 'Campo obbligatorio.',
            }}
          />
          <TextInput
            className="ten wide"
            label="Email"
            model=".email"
            errorMessages={{
              required: 'Campo obbligatorio.',
            }}
          />
          <Fields.ComboBox
            className="four wide"
            disabled={props.username === 'admin'}
            label="Livello"
            model=".role"
            options={[
              { value: 'admin', text: 'Amministratore' },
              { value: 'editor', text: 'Editor' },
              { value: 'viewer', text: 'Viewer' },
            ]}
            errorMessages={{
              required: 'Campo obbligatorio.',
            }}
          />
          <div className="ui  grid" style={{ marginTop: '7ex' }}>
            <div className="two column row">
              {props.mode === 'edit' && (
                <div className="left floated column">
                  <Button
                    type="button"
                    icon="key"
                    content="Reset Password"
                    labelPosition="left"
                    color="orange"
                    className="left floated"
                    onClick={props.onResetPassword}
                  />
                </div>
              )}
              <div className="right floated column">
                <Button
                  icon="save"
                  content="Salva"
                  labelPosition="left"
                  primary
                  disabled={props.pristine}
                  className="right floated"
                  type="submit"
                  style={{ width: '18ex' }}
                />
                <Button
                  type="button"
                  icon="cancel"
                  content="Annulla"
                  labelPosition="left"
                  className="right floated"
                  onClick={props.onCancel}
                  style={{ width: '18ex' }}
                />
              </div>
            </div>
          </div>
        </Segment>
      </Form>
    </Container>
  )
}

export default UserForm



// WEBPACK FOOTER //
// ./src/users/user-form.js